import React, { useRef } from 'react';

import { DatagridConfigurableProps as RADatagridConfigurableProps } from 'react-admin';
import { DatagridNoResults } from 'shared/react-admin/Datagrids/DatagridNoResults/DatagridNoResults';
import {
  ResizableColumns,
  useColumnResize,
} from 'shared/react-admin/Datagrids/hooks/useColumnResize';

import { DatagridConfigurableStyled } from './DatagridConfigurable.styled';

export type DatagridConfigurableProps = RADatagridConfigurableProps & {
  resizableColumns?: ResizableColumns;
};

const getDefaultRowSx = () => ({ backgroundColor: 'white' });

export const DatagridConfigurable: React.FC<DatagridConfigurableProps> = ({
  rowSx,
  empty = <DatagridNoResults />,
  resizableColumns,
  children,
  ...props
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useColumnResize(containerRef, resizableColumns);

  return (
    <div ref={containerRef}>
      <DatagridConfigurableStyled
        empty={empty}
        rowClick={false}
        rowSx={rowSx ?? getDefaultRowSx}
        {...props}
      >
        {children}
      </DatagridConfigurableStyled>
    </div>
  );
};
